import { createFileRoute } from "@tanstack/react-router"
import { SchedulesPage } from "../-components/schedules/SchedulesPage"

export const Route = createFileRoute("/app/art/schedules")({
  component: SchedulesPage,
  beforeLoad: ({ context: { t } }) => ({ getTitle: () => t && t("Schedules") }),
})
